export default __webpack_public_path__ + "static/media/SENAIT_FR_EPILOG2.6910f4cc.mp3";